import { render, staticRenderFns } from "./PersonCombobox.vue?vue&type=template&id=50d1314b&scoped=true"
import script from "./PersonCombobox.vue?vue&type=script&lang=js"
export * from "./PersonCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1314b",
  null
  
)

export default component.exports